import { createContext } from "preact";
import { useContext, useEffect } from "preact/hooks";
import type { KismetConfig } from "../types/kismet";

const KismetContext = createContext<KismetConfig>({});

export const KismetProvider = ({
  children,
}: {
  children: preact.ComponentChildren;
}) => {
  // Read config directly from window
  const config = window.KismetConfig || {};

  useEffect(() => {
    // Load custom stylesheet if provided
    if (config.theme?.stylesheet) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = config.theme.stylesheet;
      document.head.appendChild(link);
    }
  }, [config.theme?.stylesheet]);

  return (
    <KismetContext.Provider value={config}>{children}</KismetContext.Provider>
  );
};

// Hook for components to use
export const useKismetConfig = () => useContext(KismetContext);
